module.exports = __webpack_public_path__ + "static/IMG-1748-dff94fcd9878dcbe64683bc66d05fec9.jpg";